/**
 * Public agreement URLs shared by the footer and agreement dialogs.
 * Keep these paths relative to the deployed site so every entry point uses
 * the same version of each agreement.
 */
export const agreementLinks = {
  userAgreement: "/agreement/user-service-agreement.html",
  privacyPolicy: "/agreement/user-privacy-policy.html",
  childrenPrivacyPolicy: "/agreement/children-privacy-policy.html",
};

export default agreementLinks;



// WEBPACK FOOTER //
// ./src/common/agreement-links.js